import React, { Component } from 'react';

class SelectableItem extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: this.props.selected ? true : false };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.selected !== prevState.selected) {
            return { selected: nextProps.selected };
        } else return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selected !== this.props.selected) {
            this.forceUpdate();
        }
    }

    updateSelect = () => {
        this.setState({ selected: !this.state.selected });
        this.forceUpdate();
    };

    render() {
        const { name, callBackFunction } = this.props;
        const { selected } = this.state;
        return (
            <li
                className={`dropdown_li ${selected ? 'selected' : ''}`}
                onClick={() => {
                    this.updateSelect();
                    callBackFunction();
                }}>
                <span key={true} type="checkbox" name value />
                {name}
            </li>
        );
    }
}

export default SelectableItem;
